import React, { useState } from 'react';
import { isPlaceholderAssetUrl } from '@/client/utils/assets';

interface ProfileImageProps {
  name?: string | null;
  src?: string | null;
  size?: string;
  textSize?: string;
  className?: string;
}

const ProfileImage: React.FC<ProfileImageProps> = ({ 
  name,
  src,
  size = 'w-10 h-10 aspect-square',
  textSize = 'text-sm',
  className = '',
}) => {
  const [imageError, setImageError] = useState(false);

  // Only treat the explicit placeholder UUID as "no photo" — real UC URLs also use
  // /public/asset/uc/, type=image, and redirect=1 (same shape as getAssetPlaceholder).
  const showInitials =
    isPlaceholderAssetUrl(src) || imageError || !src || !name;

  // Better initials: first + last (e.g., "JP" for James Peterson)
    const names = (name || '').trim().split(/\s+/).filter(Boolean);
  const initials = (() => {
    if (names.length === 0) return '??';
    if (names.length === 1) return names[0].slice(0, 2).toUpperCase();
    return `${names[0].charAt(0)}${names[names.length - 1].charAt(0)}`.toUpperCase();
  })();

  const frameClasses = `inline-flex shrink-0 overflow-hidden rounded-full ${size} items-center justify-center ${className}`;

  const handleImageError = () => {
    setImageError(true);
  };

  if (showInitials) {
    return (
      <div className={`${frameClasses} bg-gradient-to-br from-blue-900 to-blue-950 text-white font-semibold ${textSize}`}>
        {initials}
      </div>
    );
  }

  // Real image
  return (
    <div className={frameClasses}>
      <img
        src={src || ''}
        alt={name || 'profile'}
        className="h-full w-full object-cover"
        onError={handleImageError}
      />
    </div>
  );
};
export default ProfileImage;
